import LeadsMobileList from './LeadsMobileList.component';

export default LeadsMobileList;